(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vbn-bulk-global-quote"] && !Shopify.designMode) return;
  try {
    
function vbgValidDate(value) {
  if (!value) return true;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
  if (year < 1000 || month < 1 || month > 12 || day < 1) return false;
  return day <= new Date(Date.UTC(year, month, 0)).getUTCDate();
}
function vbgFieldError(field, messages) {
  const value = field.value.trim();
  if (field.hasAttribute('data-vbg-quantity') || field.hasAttribute('data-vbg-designs')) {
    const amount = Number(value);
    if (!value || !Number.isSafeInteger(amount) || amount < Number(field.min)) return field.hasAttribute('data-vbg-quantity') ? messages.quantity : messages.designs;
  }
  if (field.required && !value) return messages.required;
  if (field.hasAttribute('data-vbg-date') && !vbgValidDate(value)) return messages.date;
  if (field.type === 'email' && value && !field.validity.valid) return messages.email;
  if (!field.validity.valid) return messages.required;
  return '';
}
function vbgInitForms() {
  document.querySelectorAll('.vbg-quote-form').forEach(form => {
    if (form.dataset.vbgBound) return;
    const error = form.querySelector('[data-vbg-error]');
    if (!error) return;
    form.dataset.vbgBound = 'true';
    form.noValidate = true;
    const fields = [...form.querySelectorAll('.vbg-field input, .vbg-field select, .vbg-field textarea')];
    let attempted = false;
    const validate = focus => {
      let first = null, message = '';
      fields.forEach(field => {
        const problem = vbgFieldError(field, error.dataset);
        field.removeAttribute('aria-invalid');
        const ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== error.id);
        if (problem) {
          field.setAttribute('aria-invalid', 'true');
          if (!first) { first = field; message = problem; ids.push(error.id); }
        }
        if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
        else field.removeAttribute('aria-describedby');
      });
      error.textContent = message;
      error.hidden = !message;
      if (first && focus) first.focus();
      return !first;
    };
    form.addEventListener('submit', event => { attempted = true; if (!validate(true)) event.preventDefault(); });
    form.addEventListener('input', () => { if (attempted) validate(false); });
    form.addEventListener('change', () => { if (attempted) validate(false); });
  });
}
if (!window.vbgSeriesListener) {
  window.vbgSeriesListener = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-vbg-series]');
    if (!link) return;
    const select = document.querySelector('#bulk-quote [data-vbg-series-select]');
    if (!select) return;
    const option = [...select.options].find(item => item.value === link.dataset.vbgSeries);
    if (!option) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', {bubbles:true}));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vbgInitForms, {once:true});
else vbgInitForms();
document.addEventListener('shopify:section:load', vbgInitForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbn-e-gallery"] && !Shopify.designMode) return;
  try {
    
const veInitGalleries=(scope=document)=>{
scope.querySelectorAll('[data-ve-gallery]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const filters=[...root.querySelectorAll('[data-ve-filter]')],cards=[...root.querySelectorAll('[data-ve-category]')],dialog=root.querySelector('[data-ve-dialog]');
 const activate=button=>{filters.forEach(f=>f.setAttribute('aria-pressed',String(f===button)));cards.forEach(c=>c.hidden=button.dataset.veFilter!=='all'&&c.dataset.veCategory!==button.dataset.veFilter)};
 filters.forEach(button=>button.addEventListener('click',()=>activate(button)));
 root.querySelectorAll('[data-ve-open-image]').forEach(button=>button.addEventListener('click',()=>{const img=new Image();img.src=button.dataset.veOpenImage;img.alt=button.dataset.veImageAlt;root.querySelector('[data-ve-dialog-image]').replaceChildren(img);dialog.showModal()}));
 root.querySelector('[data-ve-close]').addEventListener('click',()=>dialog.close());
 root.addEventListener('shopify:block:select',()=>activate(filters[0]));
});
};
veInitGalleries();document.addEventListener('shopify:section:load',e=>veInitGalleries(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbn-e-product"] && !Shopify.designMode) return;
  try {
    
const veInitProducts=(scope=document)=>{
scope.querySelectorAll('[data-ve-product]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const main=root.querySelector('.ve-product-main img'),qty=root.querySelector('[name=quantity]'),select=root.querySelector('[data-ve-variant]'),add=root.querySelector('[data-ve-add]'),dialog=root.querySelector('[data-ve-product-dialog]');
 root.querySelectorAll('[data-ve-swatch]').forEach(b=>b.addEventListener('click',()=>{if(select){select.value=b.dataset.veSwatch;select.dispatchEvent(new Event('change',{bubbles:true}))}}));
 const setImage=(src,alt)=>{if(!main||!src)return;main.src=src;main.removeAttribute('srcset');main.alt=alt||main.alt};
 root.querySelectorAll('[data-ve-thumb]').forEach(b=>b.addEventListener('click',()=>{setImage(b.dataset.veThumb,b.dataset.veAlt);root.querySelectorAll('[data-ve-thumb]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)))}));
 root.querySelectorAll('[data-ve-step]').forEach(b=>b.addEventListener('click',()=>{qty.value=String(Math.max(1,(parseInt(qty.value,10)||1)+Number(b.dataset.veStep)));qty.dispatchEvent(new Event('change',{bubbles:true}))}));
 if(select)select.addEventListener('change',()=>{const o=select.selectedOptions[0];const available=o.dataset.available==='true';add.disabled=!available;root.querySelector('[data-ve-add-text]').textContent=available?root.dataset.addLabel:root.dataset.soldLabel;root.querySelector('[data-ve-price]').textContent=o.dataset.price;setImage(o.dataset.image,o.dataset.alt);const url=new URL(window.location.href);url.searchParams.set('variant',o.value);window.history.replaceState({},'',url);root.querySelectorAll('[data-ve-swatch]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.veSwatch===o.value)))});
 root.querySelector('[data-ve-zoom]').addEventListener('click',()=>{if(!main)return;const img=new Image();img.src=main.currentSrc||main.src;img.alt=main.alt;root.querySelector('[data-ve-dialog-image]').replaceChildren(img);dialog.showModal()});
 root.querySelector('[data-ve-close]').addEventListener('click',()=>dialog.close());
});
};
veInitProducts();document.addEventListener('shopify:section:load',e=>veInitProducts(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbn-e-quote"] && !Shopify.designMode) return;
  try {
    
function veBulkValidDate(value) {
  if (!value) return true;
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!match) return false;
  const month = Number(match[1]), day = Number(match[2]), year = Number(match[3]);
  if (year < 1000 || month < 1 || month > 12 || day < 1) return false;
  return day <= new Date(year, month, 0).getDate();
}
function veBulkFieldError(field, messages) {
  const value = field.value.trim();
  if (field.hasAttribute('data-quote-quantity')) {
    const amount = Number(value);
    if (!value || !Number.isSafeInteger(amount) || amount < Number(field.min)) return messages.quantity;
  }
  if (field.required && !value) return messages.required;
  if (field.hasAttribute('data-quote-date') && !veBulkValidDate(value)) return messages.date;
  if (field.type === 'email' && value && !field.validity.valid) return messages.email;
  if (!field.validity.valid) return messages.required;
  return '';
}
function veInitBulkForms() {
  document.querySelectorAll('.ve-quote-form').forEach(form => {
    if (form.dataset.quoteBound) return;
    const error = form.querySelector('[data-quote-error]');
    if (!error) return;
    form.dataset.quoteBound = 'true';
    form.noValidate = true;
    const fields = [...form.querySelectorAll('.ve-field input, .ve-field select, .ve-field textarea')];
    let attempted = false;
    const validate = focus => {
      let first = null, message = '';
      fields.forEach(field => {
        const problem = veBulkFieldError(field, error.dataset);
        field.removeAttribute('aria-invalid');
        const ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== error.id);
        if (problem && !first) { first = field; message = problem; ids.push(error.id); field.setAttribute('aria-invalid', 'true'); }
        if (ids.length) field.setAttribute('aria-describedby', ids.join(' '));
        else field.removeAttribute('aria-describedby');
      });
      error.textContent = message;
      error.hidden = !message;
      if (first && focus) first.focus();
      return !first;
    };
    form.addEventListener('submit', event => {
      attempted = true;
      if (!validate(true)) event.preventDefault();
    });
    form.addEventListener('input', () => { if (attempted) validate(false); });
    form.addEventListener('change', () => { if (attempted) validate(false); });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', veInitBulkForms, {once:true});
else veInitBulkForms();
document.addEventListener('shopify:section:load', veInitBulkForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbn-gallery-library"] && !Shopify.designMode) return;
  try {
    
if (!window.VbnGalleryLibrary) {
  window.VbnGalleryLibrary = (() => {
    let libraries = [];
    const categories = ['y2k', 'nature', 'classic', 'seasonal'];
    const matching = library => library.ordered.filter(card => library.active === 'all' || card.dataset.v65Category === library.active);
    const apply = library => {
      const matches = matching(library);
      const shown = matches.slice(0, library.limit);
      const visible = new Set(shown);
      library.ordered.forEach(card => { card.hidden = !visible.has(card); });
      library.root.querySelectorAll('[data-v65-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.v65Filter === library.active)));
      const status = library.root.querySelector('[data-v65-status]');
      status.textContent = status.dataset.template.replace('__shown__', shown.length).replace('__total__', matches.length);
      library.root.querySelector('[data-v65-more]').hidden = shown.length >= matches.length;
      library.root.querySelector('[data-v65-empty]').hidden = matches.length !== 0;
    };
    const activate = (library, category) => {
      library.active = category;
      library.limit = library.pageSize;
      apply(library);
    };
    const followHash = () => {
      const category = location.hash.startsWith('#gallery-') ? location.hash.slice(9) : '';
      const library = libraries[0];
      if (!library || !(category === 'all' || categories.includes(category))) return;
      activate(library, category);
      library.root.scrollIntoView({block:'start', behavior:'auto'});
    };
    const restore = excluded => {
      libraries.forEach(library => {
        if (library.dialog.open) library.dialog.close();
        library.entries.forEach(({card, owner, home}) => {
          if (owner.isConnected && !excluded?.contains(owner)) {
            card.hidden = false;
            home.append(card);
          } else card.remove();
        });
      });
      document.body.classList.remove('v65-modal-open');
      libraries = [];
    };
    const rebuild = excluded => {
      const previous = new Map(libraries.map(library => [library.key, {active:library.active, limit:library.limit}]));
      restore(excluded);
      const roots = [...document.querySelectorAll('[data-v65-library]')].filter(root => !excluded?.contains(root));
      roots.forEach(root => { delete root.dataset.v65Merged; });
      const keys = [...new Set(roots.map(root => root.dataset.v65Library))];
      keys.forEach(key => {
        const sources = roots.filter(root => root.dataset.v65Library === key);
        const root = sources.find(source => source.dataset.v65Controls === 'true');
        if (!root) return;
        const entries = sources.flatMap(owner => {
          const home = owner.querySelector('[data-v65-grid]');
          return [...home.querySelectorAll('[data-v65-card]')].map(card => ({card, owner, home}));
        });
        const buckets = categories.map(category => entries.filter(entry => entry.card.dataset.v65Category === category).map(entry => entry.card));
        const ordered = [];
        for (let index = 0; index < Math.max(0, ...buckets.map(bucket => bucket.length)); index++) buckets.forEach(bucket => { if (bucket[index]) ordered.push(bucket[index]); });
        entries.forEach(entry => { if (!ordered.includes(entry.card)) ordered.push(entry.card); });
        const grid = root.querySelector('[data-v65-grid]');
        grid.append(...ordered);
        sources.filter(source => source !== root).forEach(source => { source.dataset.v65Merged = 'true'; });
        const pageSize = Number(root.dataset.v65PageSize) || 16;
        const saved = previous.get(key);
        const library = {key, root, grid, entries, ordered, pageSize, active:saved?.active || 'all', limit:saved?.limit || pageSize, dialog:root.querySelector('[data-v65-dialog]'), opener:null, current:null};
        root.querySelector('.v65-filters').hidden = false;
        root.querySelector('[data-v65-pagination]').hidden = false;
        root.querySelectorAll('[data-v65-count]').forEach(counter => {
          counter.textContent = counter.dataset.v65Count === 'all' ? ordered.length : ordered.filter(card => card.dataset.v65Category === counter.dataset.v65Count).length;
        });
        libraries.push(library);
        apply(library);
      });
      followHash();
    };
    const viewer = (library, card) => {
      const opener = card.querySelector('[data-v65-open]');
      if (!opener) return;
      library.current = card;
      const image = library.root.querySelector('[data-v65-full-image]');
      image.alt = opener.dataset.v65Alt;
      image.src = opener.href;
      library.root.querySelector('[data-v65-full-title]').textContent = card.dataset.v65Title;
      library.root.querySelector('[data-v65-full-series]').textContent = card.dataset.v65Series;
      const cards = matching(library);
      library.root.querySelector('[data-v65-position]').textContent = `${cards.indexOf(card) + 1} / ${cards.length}`;
      if (!library.dialog.open) {
        library.opener = opener;
        library.dialog.showModal();
        document.body.classList.add('v65-modal-open');
      }
    };
    document.addEventListener('click', event => {
      const jump = event.target.closest('a[href^="#gallery-"]');
      if (jump) {
        const category = jump.getAttribute('href').slice('#gallery-'.length);
        const library = libraries[0];
        if (library && (category === 'all' || categories.includes(category))) {
          event.preventDefault();
          activate(library, category);
          history.replaceState(null, '', '#gallery-' + category);
          const button = library.root.querySelector(`[data-v65-filter="${category}"]`);
          button.focus({preventScroll:true});
          library.root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        }
        return;
      }
      const library = libraries.find(item => item.root.contains(event.target));
      if (!library) return;
      const filter = event.target.closest('[data-v65-filter]');
      if (filter) { activate(library, filter.dataset.v65Filter); return; }
      if (event.target.closest('[data-v65-more]')) {
        const oldLimit = library.limit;
        library.limit += library.pageSize;
        apply(library);
        matching(library)[oldLimit]?.querySelector('[data-v65-open]')?.focus({preventScroll:true});
        return;
      }
      const opener = event.target.closest('[data-v65-open]');
      if (opener) { event.preventDefault(); viewer(library, opener.closest('[data-v65-card]')); return; }
      if (event.target.closest('[data-v65-close]') || event.target === library.dialog) { library.dialog.close(); return; }
      const previous = event.target.closest('[data-v65-prev]');
      const next = event.target.closest('[data-v65-next]');
      if (previous || next) {
        const cards = matching(library), index = cards.indexOf(library.current);
        if (cards.length) viewer(library, cards[(index + (next ? 1 : -1) + cards.length) % cards.length]);
      }
    });
    document.addEventListener('close', event => {
      const library = libraries.find(item => item.dialog === event.target);
      if (!library) return;
      document.body.classList.remove('v65-modal-open');
      if (library.opener?.isConnected && !library.opener.closest('[hidden]')) library.opener.focus({preventScroll:true});
    }, true);
    document.addEventListener('keydown', event => {
      const library = libraries.find(item => item.dialog.open);
      if (!library || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      library.root.querySelector(event.key === 'ArrowLeft' ? '[data-v65-prev]' : '[data-v65-next]').click();
    });
    const reveal = (library, card) => {
      library.active = card.dataset.v65Category;
      library.limit = Math.max(library.pageSize, matching(library).indexOf(card) + 1);
      apply(library);
      card.scrollIntoView({block:'center', behavior:'auto'});
    };
    document.addEventListener('shopify:block:select', event => {
      const library = libraries.find(item => item.entries.some(entry => entry.card.dataset.v65Block === event.detail.blockId));
      if (library) reveal(library, library.entries.find(entry => entry.card.dataset.v65Block === event.detail.blockId).card);
    });
    document.addEventListener('shopify:section:select', event => {
      const library = libraries.find(item => item.entries.some(entry => entry.owner.dataset.v65Owner === event.detail.sectionId));
      if (!library) return;
      if (library.root.dataset.v65Owner === event.detail.sectionId) { activate(library, 'all'); return; }
      const entry = library.entries.find(item => item.owner.dataset.v65Owner === event.detail.sectionId);
      if (entry) reveal(library, entry.card);
    });
    window.addEventListener('hashchange', followHash);
    document.addEventListener('shopify:section:load', () => rebuild());
    document.addEventListener('shopify:section:unload', event => rebuild(event.target));
    document.addEventListener('shopify:section:reorder', () => rebuild());
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => rebuild(), {once:true});
    else rebuild();
    return {rebuild};
  })();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vbn-reference-page"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const setup=(scope=document)=>{
      scope.querySelectorAll('[data-vbn-reference]').forEach(page=>{
        if(page.dataset.commonReady)return;
        page.dataset.commonReady='true';
        page.addEventListener('click',event=>{
          if(event.target.closest('[data-vbn-search-open]'))page.querySelector('[data-vbn-search-dialog]')?.showModal();
          if(event.target.closest('[data-vbn-social-pending]'))page.querySelector('[data-vbn-social-dialog]')?.showModal();
          const close=event.target.closest('[data-vbn-dialog-close]');
          if(close)close.closest('dialog')?.close();
        });
        page.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}}));
      });
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
    document.addEventListener('shopify:section:load',event=>setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
